import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    title: 'title-3 bg-white',
    shopAll: 'flex gap-1 bg-white py-3 fw-medium'
  }
} satisfies CMSConfig['megaMenuL1Mobile']
